module.exports = __webpack_public_path__ + "img/horn.5cbc09e9.png";